import dayjs from 'dayjs';
import { createSelector } from 'reselect';

export const archivedEventsSelector: Selector<
  RootState,
  DomainEntity<Event> | undefined
> = (state: RootState) => state.domain.archivedEvents;

export const sortByReleaseAtEventsSelector = createSelector(
  [archivedEventsSelector],
  (events): any => {
    const grouped = {};
    const listEvents = events?.listEvent;

    if (listEvents) {
      for (const eventItem of listEvents) {
        const key = dayjs(eventItem.event_at).format('YYYYMMDD');
        const byReleaseAt: any[] = grouped[key] ? grouped[key] : [];
        byReleaseAt.push(eventItem);
        grouped[key] = byReleaseAt;
      }
    }

    return grouped;
  }
);

// types
export type GroupedLaunch = {
  [key: string]: [];
};

import type { Selector } from 'reselect';
import type { RootState, DomainEntity } from '@/store/index';
import type Event from '@/domain/events/index';
